import { useBudget } from '../store/BudgetContext';
import { theme } from '../theme';

/**
 * Статус синка словом (Антверпен 2.0 §7), без светофорных точек:
 * «офлайн · N» sub / «повторить · N» глиной (тапабельно) / «синк · N» на время
 * дренажа. Синхронизированное состояние опускается — тишина и есть норма.
 */
export function SyncIndicator() {
  const { sync, queue, failedCount, retryFailed, drainNow } = useBudget();

  const pendingCount = queue.filter((e) => e.status === 'pending').length;

  let label: string | null = null;
  let color: string = theme.colors.sub;
  let underline = false;
  let action: (() => void) | null = null;

  if (failedCount > 0) {
    label = `повторить · ${failedCount}`;
    color = theme.colors.red;
    underline = true;
    action = () => void retryFailed();
  } else if (sync === 'syncing') {
    label = pendingCount > 0 ? `синк · ${pendingCount}` : 'синк';
  } else if (sync === 'offline' || pendingCount > 0) {
    label = pendingCount > 0 ? `офлайн · ${pendingCount}` : 'офлайн';
    action = () => void drainNow();
  }

  if (!label) return null; // синхронизировано — слово опускаем

  return (
    <button
      onClick={() => action?.()}
      aria-label={label}
      style={{
        background: 'transparent',
        border: 'none',
        padding: '6px 10px',
        cursor: action ? 'pointer' : 'default',
        fontFamily: theme.font,
        textTransform: 'uppercase',
        letterSpacing: '.14em',
        fontSize: 10.5,
        color,
        borderBottom: underline ? `1px solid ${color}` : 'none',
      }}
    >
      {label}
    </button>
  );
}
